import { 
    DELETEIPDVISITS, 
    GETALLIPDVISITS, 
    GETIPDVISITS, 
    UPDATEIPDVISITS ,
    DELETEIPDOUTBILL,
    GETALLIPDOUTBILL,
    GETIPDOUTBILL,
    UPDATEIPDOUTBILL,
    CREATEIPDINSYMPTOMS,
    GETIPDINSYMPTOMS,
    UPDATEIPDINSYMPTOMS,
    DELETEIPDINSYMPTOMS,
    CREATEIPDINCOBORBIDITY,
    GETIPDINCOBORBIDITY,
    UPDATEIPDINCOBORBIDITY,
    DELETEIPDINCOBORBIDITY,
    CREATEIPDININVESTIGATION,
    GETIPDININVESTIGATION,
    UPDATEIPDININVESTIGATION,
    DELETEIPDININVESTIGATION,
    CREATEIPDNURSENOTE,
    GETIPDNURSENOTE,
    UPDATEIPDNURSENOTE,
    DELETEIPDNURSENOTE,
    CREATEIPDMEDICATION,
    GETIPDMEDICATION,
    UPDATEIPDMEDICATION,
    DELETEIPDMEDICATION,
    CREATEIPDDISCHARGE,
    GETIPDDISCHARGE,
    UPDATEIPDDISCHARGE,
    DELETEIPDDISCHARGE,
    CREATEIPDPRESCRIPTIONDATA,
    GETIPDPRESCRIPTIONDATA,
    UPDATEIPDPRESCRIPTIONDATA,
    DELETEIPDPRESCRIPTIONDATA,
    CREATEIPDPRESCRIPTIONMEDICINE,
    GETIPDPRESCRIPTIONMEDICINE,
    UPDATEIPDPRESCRIPTIONMEDICINE,
    DELETEIPDPRESCRIPTIONMEDICINE,
    CREATEIPDCONSULTANTREGISTER,
    GETIPDCONSULTANTREGISTER,
    UPDATEIPDCONSULTANTREGISTER,
    DELETEIPDCONSULTANTREGISTER,
    GETIPDPAYMENT,
    UPDATEIPDPAYMENT,
    DELETEIPDPAYMENT,
    GETALLIPDPAYMENT,
    GETIPDBEDHISTORY,
    UPDATEIPDBEDHISTORY,
    DELETEIPDBEDHISTORY,
    GETALLIPDBEDHISTORY,
    GETIPDOBSTETRIC,
    UPDATEIPDOBSTETRIC,
    DELETEIPDOBSTETRIC,
    GETALLIPDOBSTETRIC,
    GETIPDPOSTNATAL,
    UPDATEIPDPOSTNATAL,
    DELETEIPDPOSTNATAL,
    GETALLIPDPOSTNATAL,
    GETIPDANTENATAL,
    UPDATEIPDANTENATAL,
    DELETEIPDANTENATAL,
    GETALLIPDANTENATAL,
    GETIPDVITAL,
    UPDATEIPDVITAL,
    DELETEIPDVITAL,
    GETALLIPDVITAL,
    CREATECONSULTANTSYMPTOMS,
    GETCONSULTANTSYMPTOMS,
    UPDATECONSULTANTSYMPTOMS,
    DELETECONSULTANTSYMPTOMS,
    GETALLIPDTIMELINEHISTORY,
    GETIPDTIMELINEHISTORY,
    UPDATEIPDTIMELINEHISTORY,
    DELETEIPDTIMELINEHISTORY
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
    case GETIPDVISITS:
            return {
                    ...state,
                    ipdvisitsList: action.payload.data,
                    }
    case GETALLIPDVISITS:
            return {
                    ...state,
                    allipdvisitsList: action.payload.data,
                    }
    case UPDATEIPDVISITS:
            return {
                    ...state,
                    ipdvisitsUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDVISITS:
             return {
                 ...state,
                 ipdvisitsDeleteStatus: action.payload.success,
                    } 
    case GETIPDOUTBILL:
            return {
                    ...state,
                    ipdinbillList: action.payload.data,
                    }
    case UPDATEIPDOUTBILL:
            return {
                    ...state,
                    ipdinbillUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDOUTBILL:
             return {
                 ...state,
                 ipdinbillDeleteStatus: action.payload.success,
                    } 
    case GETALLIPDOUTBILL:
                return {
                        ...state,
                        allipdinbillList: action.payload.data,
                        }
    case GETIPDPAYMENT:
            return {
                    ...state,
                    ipdpaymentList: action.payload.data,
                    }
    case UPDATEIPDPAYMENT:
            return {
                    ...state,
                    ipdpaymentUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDPAYMENT:
             return {
                 ...state,
                 ipdpaymentDeleteStatus: action.payload.success,
                    } 
    case GETALLIPDPAYMENT:
                return {
                        ...state,
                        ipdpaymentList: action.payload.data,
                        }
    case CREATEIPDINSYMPTOMS:
            return {
                ...state,
            ipdinsymptomsSaveStatus: action.payload.success,
            }
    case GETIPDINSYMPTOMS:
            return {
                    ...state,
                    ipdinsymptomsList: action.payload.data,
                    }
    case UPDATEIPDINSYMPTOMS:
            return {
                    ...state,
                    ipdinsymptomsUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDINSYMPTOMS:
             return {
                 ...state,
                 ipdinsymptomsDeleteStatus: action.payload.success,
                    } 
    
   case CREATEIPDINCOBORBIDITY:
            return {
                ...state,
            ipdincomorbiditySaveStatus: action.payload.success,
            }
    case GETIPDINCOBORBIDITY:
            return {
                    ...state,
                    ipdincomorbidityList: action.payload.data,
                    }
    case UPDATEIPDINCOBORBIDITY:
            return {
                    ...state,
                    ipdincomorbidityUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDINCOBORBIDITY:
             return {
                 ...state,
                 ipdincomorbidityDeleteStatus: action.payload.success,
                    } 
    case CREATEIPDININVESTIGATION:
            return {
                ...state,
            ipdininvestigationSaveStatus: action.payload.success,
            }
    case GETIPDININVESTIGATION:
            return {
                    ...state,
                    ipdininvestigationList: action.payload.data,
                    }
    case UPDATEIPDININVESTIGATION:
            return {
                    ...state,
                    ipdininvestigationUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDININVESTIGATION:
             return {
                 ...state,
                 ipdininvestigationDeleteStatus: action.payload.success,
                    } 
    case CREATEIPDNURSENOTE:
            return {
                ...state,
            ipdnursenoteSaveStatus: action.payload.success,
            }
    case GETIPDNURSENOTE:
            return {
                    ...state,
                    ipdnursenoteList: action.payload.data,
                    }
    case UPDATEIPDNURSENOTE:
            return {
                    ...state,
                    ipdnursenoteUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDNURSENOTE:
             return {
                 ...state,
                 ipdnursenoteDeleteStatus: action.payload.success,
                    } 
    case CREATEIPDMEDICATION:
            return {
                ...state,
            ipdmedicationSaveStatus: action.payload.success,
            }
    case GETIPDMEDICATION:
            return {
                    ...state,
                    ipdmedicationList: action.payload.data,
                    }
    case UPDATEIPDMEDICATION:
            return {
                    ...state,
                    ipdmedicationUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDMEDICATION:
             return {
                 ...state,
                 ipdmedicationDeleteStatus: action.payload.success,
                    } 
   case CREATEIPDDISCHARGE:
            return {
                ...state,
            ipddischargeSaveStatus: action.payload.success,
            }
    case GETIPDDISCHARGE:
            return {
                    ...state,
                    ipddischargeList: action.payload.data,
                    }
    case UPDATEIPDDISCHARGE:
            return {
                    ...state,
                    ipddischargeUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDDISCHARGE:
             return {
                 ...state,
                 ipddischargeDeleteStatus: action.payload.success,
                    }
    case CREATEIPDPRESCRIPTIONDATA:
            return {
                ...state,
                ipdprescriptionSaveStatus: action.payload.success,
            }
   case GETIPDPRESCRIPTIONDATA:
                return {
                        ...state,
                        ipdprescriptionList: action.payload.data,
                        }
   case UPDATEIPDPRESCRIPTIONDATA:
                return {
                        ...state,
                        ipdprescriptionUpdateStatus: action.payload.success,
                        }   

  case DELETEIPDPRESCRIPTIONDATA:
                 return {
                     ...state,
                     ipdprescriptionDeleteStatus: action.payload.success,
                        } 

  case CREATEIPDPRESCRIPTIONMEDICINE:
            return {
                ...state,
                ipdprescriptionmedicineSaveStatus: action.payload.success,
            }
  case GETIPDPRESCRIPTIONMEDICINE:
                return {
                        ...state,
                        ipdprescriptionmedicineList: action.payload.data,
                        }
  case UPDATEIPDPRESCRIPTIONMEDICINE:
                return {
                        ...state,
                        ipdprescriptionmedicineUpdateStatus: action.payload.success,
                        }   

  case DELETEIPDPRESCRIPTIONMEDICINE:
                 return {
                     ...state,
                     ipdprescriptionmedicineDeleteStatus: action.payload.success,
                        } 
    case CREATEIPDCONSULTANTREGISTER:
            return {
                ...state,
            ipdconsultantregisterSaveStatus: action.payload.success,
            }
    case GETIPDCONSULTANTREGISTER:
            return {
                    ...state,
                    ipdconsultantregisterList: action.payload.data,
                    }
    case UPDATEIPDCONSULTANTREGISTER:
            return {
                    ...state,
                    ipdconsultantregisterUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDCONSULTANTREGISTER:
             return {
                 ...state,
                 ipdconsultantregisterDeleteStatus: action.payload.success,
                    }
    case GETIPDBEDHISTORY:
            return {
                    ...state,
                    ipdbedhistoryList: action.payload.data,
                    }
    case UPDATEIPDBEDHISTORY:
            return {
                    ...state,
                    ipdbedhistoryUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDBEDHISTORY:
             return {
                 ...state,
                 ipdbedhistoryDeleteStatus: action.payload.success,
                    } 
    case GETALLIPDBEDHISTORY:
                return {
                        ...state,
                        ipdbedhistoryList: action.payload.data,
                        }  
    case GETIPDOBSTETRIC:
            return {
                    ...state,
                    ipdobstetricList: action.payload.data,
                    }
    case UPDATEIPDOBSTETRIC:
            return {
                    ...state,
                    ipdobstetricUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDOBSTETRIC:
             return {
                 ...state,
                 ipdobstetricDeleteStatus: action.payload.success,
                    } 
    case GETALLIPDOBSTETRIC:
                return {
                        ...state,
                        ipdobstetricList: action.payload.data,
                        }
    case GETIPDPOSTNATAL:
            return {
                    ...state,
                    ipdpostnatalList: action.payload.data,
                    }
    case UPDATEIPDPOSTNATAL:
            return {
                    ...state,
                    ipdpostnatalUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDPOSTNATAL:
             return {
                 ...state,
                 ipdpostnatalDeleteStatus: action.payload.success,
                    } 
    case GETALLIPDPOSTNATAL:
                return {
                        ...state,
                        ipdpostnatalList: action.payload.data,
                        }
   case GETIPDANTENATAL:
            return {
                    ...state,
                    ipdantenatalList: action.payload.data,
                    }
    case UPDATEIPDANTENATAL:
            return {
                    ...state,
                    ipdantenatalUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDANTENATAL:
             return {
                 ...state,
                 ipdantenatalDeleteStatus: action.payload.success,
                    } 
    case GETALLIPDANTENATAL:
                return {
                        ...state,
                        ipdantenatalList: action.payload.data,
                        }
    case GETIPDVITAL:
            return {
                    ...state,
                    ipdvitalList: action.payload.data,
                    }
    case UPDATEIPDVITAL:
            return {
                    ...state,
                    ipdvitalUpdateStatus: action.payload.success,
                    }   

    case DELETEIPDVITAL:
             return {
                 ...state,
                 ipdvitalDeleteStatus: action.payload.success,
                    } 
    case GETALLIPDVITAL:
                return {
                        ...state,
                        ipdvitalList: action.payload.data,
                        }
   case CREATECONSULTANTSYMPTOMS:
            return {
                ...state,
            consultantsymptomsSaveStatus: action.payload.success,
            }
    case GETCONSULTANTSYMPTOMS:
            return {
                    ...state,
                    consultantsymptomsList: action.payload.data,
                    }
    case UPDATECONSULTANTSYMPTOMS:
            return {
                    ...state,
                    consultantsymptomsUpdateStatus: action.payload.success,
                    }   

    case DELETECONSULTANTSYMPTOMS:
             return {
                 ...state,
                 consultantsymptomsDeleteStatus: action.payload.success,
                    }
    case GETALLIPDTIMELINEHISTORY:
                        return {
                                ...state,
                                ipdtimelineList: action.payload.data,
                                }
            case GETIPDTIMELINEHISTORY:
                    return {
                            ...state,
                            ipdtimelineList: action.payload.data,
                            }
            case UPDATEIPDTIMELINEHISTORY:
                    return {
                            ...state,
                            ipdtimelineUpdateStatus: action.payload.success,
                            }   
        
            case DELETEIPDTIMELINEHISTORY:
                     return {
                         ...state,
                         ipdtimelineDeleteStatus: action.payload.success,
                            } 
           
                    default:
                        return state
                         }

                     }